export const prefixBase64 = 'base64:';
export const prefixJson64 = 'json64:';